import { type SelectOption } from '@aus-platform/design-system';
import { PointShape } from './enums';
import { upperFirst } from 'lodash';

export const pointShapeOptions: SelectOption<PointShape>[] = [
  {
    label: upperFirst(PointShape.Square),
    value: PointShape.Square,
  },
  {
    label: upperFirst(PointShape.Circle),
    value: PointShape.Circle,
  },
];

export const MAX_POINT_SIZE = 10;
export const INITIAL_CVTILES_OPACITY = 100;
